import React from 'react';
import { ReactComponent as HikingPersonIcon } from '../../icons/hiking-person.svg';
import { ReactComponent as MuseumSvg } from '../../icons/museum.svg';
import { ReactComponent as RestaurantSvg } from '../../icons/resturant.svg';
import { ReactComponent as HotelSvg } from '../../icons/hotel.svg';
import { ReactComponent as FlightSvg } from '../../icons/flight.svg';
import { ReactComponent as NatureSvg } from '../../icons/nature.svg';
import { ReactComponent as Attraction } from '../../icons/attraction.svg';
import { ReactComponent as RouteSvg } from '../../icons/route.svg';



const iconStyle = {
  fontSize: '1.2em',
  verticalAlign: 'middle',
  filter: 'drop-shadow(0 1px 1px #b6c3d1)',
  marginRight: 6,
  marginLeft: 2,
  display: 'inline-block',
  color: '#1976d2',
};

// Route icon: hiking person SVG
const HikingIcon = () => (
  <HikingPersonIcon style={iconStyle} width={24} height={24} />
);

// Route icon: route SVG (only shown when app creates route events, not in dropdown)
const RouteIcon = () => (
  <RouteSvg style={iconStyle} width={24} height={24} />
);

// Museum icon: imported SVG
const MuseumIcon = () => (
  <MuseumSvg style={iconStyle} width={24} height={24} />
);

// Restaurant icon: imported SVG
const RestaurantIcon = () => (
  <RestaurantSvg style={iconStyle} width={24} height={24} />
);

// Hotel icon: imported SVG
const HotelIcon = () => (
  <HotelSvg style={iconStyle} width={24} height={24} />
);

// Sightseeing icon: nature/park SVG
const SightseeingIcon = () => (
  <NatureSvg style={iconStyle} width={24} height={24} />
);

// Amusement park icon: attraction SVG
const AmusementParkIcon = () => (
  <Attraction style={iconStyle} width={24} height={24} />
);

// Flight icon: imported SVG
const FlightIcon = () => (
  <FlightSvg style={iconStyle} width={24} height={24} />
);

// Theater masks for Show
const ShowIcon = () => (
  <svg width="26" height="22" viewBox="0 0 32 24" style={iconStyle} fill="none">
    <ellipse cx="10" cy="14" rx="7" ry="7" fill="#4967ebff" opacity="0.18"/>
    <ellipse cx="22" cy="10" rx="7" ry="7" fill="#4967ebff" opacity="0.18"/>
    <path d="M5 14c0 3 3 5 5 5s5-2 5-5V8c0-3-3-5-5-5S5 5 5 8v6z" fill="#4967ebff"/>
    <path d="M27 10c0 3-3 5-5 5s-5-2-5-5V4c0-3 3-5 5-5s5 2 5 5v6z" fill="#4967ebff"/>
    <ellipse cx="8" cy="13" rx="1" ry="0.5" fill="#fff"/>
    <ellipse cx="12" cy="13" rx="1" ry="0.5" fill="#fff"/>
    <ellipse cx="20" cy="9" rx="1" ry="0.5" fill="#fff"/>
    <ellipse cx="24" cy="9" rx="1" ry="0.5" fill="#fff"/>
    <path d="M8 16c1 1 3 1 4 0" stroke="#fff" strokeWidth="0.7" fill="none"/>
    <path d="M20 12c1 1 3 1 4 0" stroke="#fff" strokeWidth="0.7" fill="none"/>
  </svg>
);

// Running person for Activity
const ActivityIcon = () => (
  <svg width="26" height="22" viewBox="0 0 32 24" style={iconStyle} fill="none">
    <circle cx="16" cy="7" r="3" fill="#fbc02d"/>
    <path d="M16 10v4l-4 4" stroke="#fbc02d" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 10l4 2 4 6" stroke="#fbc02d" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 14l-2 6" stroke="#fbc02d" strokeWidth="2" strokeLinecap="round"/>
    <path d="M20 12l2 8" stroke="#fbc02d" strokeWidth="2" strokeLinecap="round"/>
    <ellipse cx="16" cy="21" rx="10" ry="2" fill="#fbc02d" opacity="0.18"/>
  </svg>
);

// Guided tour (map)
const GuidedTourIcon = () => (
  <svg width="26" height="22" viewBox="0 0 32 24" style={iconStyle} fill="none">
    <rect x="4" y="4" width="24" height="16" rx="4" fill="#0288d1" opacity="0.18"/>
    <path d="M8 18l6-12 6 12" stroke="#0288d1" strokeWidth="2" fill="none"/>
    <circle cx="16" cy="12" r="2" fill="#0288d1"/>
  </svg>
);

// Other (question mark)
const OtherIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" style={iconStyle} fill="none">
    <circle cx="12" cy="12" r="10" fill="#757575" opacity="0.18"/>
    <text x="12" y="17" textAnchor="middle" fontSize="16" fill="#757575" fontWeight="bold">?</text>
  </svg>
);

export const EVENT_TYPE_ICONS = {
  Location: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style={iconStyle} fill="none">
      <ellipse cx="12" cy="10" rx="4" ry="5.5" fill="#1976d2" opacity="0.18"/>
      <path d="M12 21s7-7.58 7-12A7 7 0 0 0 5 9c0 4.42 7 12 7 12z" fill="#1976d2"/>
      <circle cx="12" cy="9" r="2.5" fill="#fff"/>
      <circle cx="12" cy="9" r="1.2" fill="#1976d2"/>
    </svg>
  ),
  Route: <RouteIcon />,
  Hiking: <HikingIcon />,
  Show: <ShowIcon />,
  Museum: <MuseumIcon />,
  Restaurant: <RestaurantIcon />,
  Hotel: <HotelIcon />,
  Sightseeing: <SightseeingIcon />,
  'Amusement park': <AmusementParkIcon />,
  Activity: <ActivityIcon />,
  'Guided tour': <GuidedTourIcon />,
  Flight: <FlightIcon />,
  Other: <OtherIcon />,
};

// Define the event types array to ensure consistency across all components
// Note: 'Route' is intentionally excluded from this list as routes are created by the app, not manually selected
export const EVENT_TYPES = [
  'Location', 'Hiking', 'Show', 'Museum', 'Restaurant', 'Hotel', 'Sightseeing', 'Amusement park', 'Activity', 'Guided tour', 'Flight', 'Other'
];